import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface LatLngCoordinates {
  lat: number;
  lng: number;
}

/**
 * Same shape as LatLngCoordinates, but `bindCustomerDetails` (customer-details.component.ts)
 * forwards latitude/longitude straight from the API response without coercing to number first,
 * so consumers may genuinely receive numeric strings here.
 */
export interface LatLngLike {
  lat: number | string;
  lng: number | string;
}

export interface AutoCompleteQuery {
  query: string;
}

@Injectable({
  providedIn: 'root',
})
export class AhoyCustomerInteractionService {
  private address = new Subject<LatLngCoordinates>();
  private addressRes = new Subject<unknown>();
  private validateAddress = new Subject<LatLngLike>();
  private validateAddressRes = new Subject<unknown>();
  private autoCompleteQuery = new Subject<AutoCompleteQuery>();
  private autoCompleteRes = new Subject<unknown>();
  private selectedAddress = new Subject<string>();
  private selectedAddressRes = new Subject<unknown>();
  constructor() {}

  // auto complete sevices
  getAutoCompleteQuery(): Observable<AutoCompleteQuery> {
    return this.autoCompleteQuery.asObservable();
  }

  sendAutoCompleteQuery(query: AutoCompleteQuery) {
    this.autoCompleteQuery.next(query);
  }

  getAutoCompleteRes(): Observable<unknown> {
    return this.autoCompleteRes.asObservable();
  }

  sendAutoCompleteRes(res: unknown) {
    this.autoCompleteRes.next(res);
  }

  // selected Address sevices
  getSelectedAddress(): Observable<string> {
    return this.selectedAddress.asObservable();
  }

  sendSelectedAddress(placeId: string) {
    this.selectedAddress.next(placeId);
  }

  getSelectedAddressRes(): Observable<unknown> {
    return this.selectedAddressRes.asObservable();
  }

  sendSelectedAddressRes(res: unknown) {
    this.selectedAddressRes.next(res);
  }

  // Address from lat, lng sevices
  sendAdressByLatLng(lat: number, lng: number) {
    this.address.next({ lat, lng });
  }

  getAddressByLatLng(): Observable<LatLngCoordinates> {
    return this.address.asObservable();
  }

  sendAddressRes(res: unknown) {
    this.addressRes.next(res);
  }

  getAddressRes(): Observable<unknown> {
    return this.addressRes.asObservable();
  }

  // address validation by lat, lng
  sendValidateAddressByLatLng(lat: number | string, lng: number | string) {
    this.validateAddress.next({ lat, lng });
  }

  getValidateAddressByLatLng(): Observable<LatLngLike> {
    return this.validateAddress.asObservable();
  }

  sendValidateAddressRes(res: unknown) {
    this.validateAddressRes.next(res);
  }

  getValidateAddressRes(): Observable<unknown> {
    return this.validateAddressRes.asObservable();
  }
}
